/**
 * OI Strike Charts service — talks to /api/v1/oi-strike-charts/* (see
 * app.api.v1.oi_strike_charts). Sibling to oiChartsService (Phase B),
 * never modifying it.
 */
import api from "@/services/api";
import type { StrikeChartHistoryResponse } from "@/types";

export const oiStrikeChartsService = {
  async getHistory(symbol: string, tradeDate?: string): Promise<StrikeChartHistoryResponse> {
    const { data } = await api.get<StrikeChartHistoryResponse>(
      `/oi-strike-charts/${symbol}/history`,
      tradeDate ? { params: { trade_date: tradeDate } } : undefined,
    );
    return data;
  },
};

export default oiStrikeChartsService;
